import { Box, Card, CardContent, Grid, Chip, Typography } from "@mui/material";
import { plans } from "./premiumData";

function PricingCards() {
    return (
        <Grid container spacing={2} sx={{ mb: 3 }}>
            {plans.map(plan => (
                <Grid key={plan.label} size={{ xs: 12, sm: 6 }}>
                    <Card sx={{
                        height: '100%',
                        borderRadius: '16px',
                        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
                        // Der "Beliebt"-Plan sticht nun mit einem goldenen Rand heraus
                        border: plan.featured
                            ? '2px solid rgba(212, 175, 55, 0.5)'
                            : '1px solid rgba(212, 175, 55, 0.15)',
                        cursor: 'pointer', position: 'relative', overflow: 'visible',
                        transition: 'all 0.3s ease',
                        boxShadow: plan.featured ? '0 4px 20px rgba(212, 175, 55, 0.05)' : 'none',
                        '&:hover': {
                            transform: 'translateY(-2px)',
                            borderColor: 'rgba(212, 175, 55, 0.6)',
                            boxShadow: '0 6px 24px rgba(212, 175, 55, 0.12)'
                        }
                    }}>
                        {plan.featured && (
                            <Chip label="Beliebt" size="small" sx={{
                                position: 'absolute', top: -10, right: 12,
                                bgcolor: '#b38728', color: '#fff',
                                fontWeight: 700, fontSize: '0.7rem', height: 20
                            }} />
                        )}
                        <CardContent sx={{ p: { xs: 2.5, md: 3 } }}>
                            <Typography variant="caption" sx={{ color: plan.featured ? '#d4af37' : '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                                {plan.label}
                            </Typography>
                            <Box display="flex" alignItems="baseline" gap={0.5} mt={0.5}>
                                <Typography sx={{ fontSize: '2rem', fontWeight: 700, color: '#f1f5f9', lineHeight: 1 }}>
                                    {plan.price}
                                </Typography>
                                <Typography variant="caption" sx={{ color: '#64748b' }}>{plan.sub}</Typography>
                            </Box>
                            <Typography variant="caption" sx={{ color: '#94a3b8', display: 'block', mt: 0.5 }}>
                                {plan.desc}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
}

export default PricingCards;
